import React, { useState } from "react";
import "../assets/MenuPrincipal.css";
import Previews from "./Previews";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import Modal from "./ModalMain";
import { Dropdown, DropdownButton } from "react-bootstrap";
import ImagenesSeleccionadas from "./ImagenesSeleccionadas";

// Import imágenes de favicons
import camiseta from "../assets/favicons/camiseta.png";
import camisetalarga from "../assets/favicons/camisetalarga.png";
import hoodie from "../assets/favicons/hoodie.png";
import pants from "../assets/favicons/pants.png";

// Imágenes de modelos
import Hombre2 from "../assets/imagenesIA/Hombre 3.png";
import Niña4 from "../assets/imagenesIA/Niña 4.png";
import Mujer from "../assets/imagenesMangaLarga/AdolescenteM3.png";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

export default function MenuPrincipal({
  onGenerarImagen,
  onImageGenerated,
  onLoadingChange, // Callback fired con la URL cuando termine
}) {
  const [imagen, setImagen] = useState(null);
  const [resultUrl, setResultUrl] = useState(null);

  const modeloPorDefecto = { name: "Adolescente", img: Mujer };
  const [modeloSeleccionado, setModeloSeleccionado] =
    useState(modeloPorDefecto);
  const [modelosEnPantalla, setModelosEnPantalla] = useState([
    { name: "Hombre", img: Hombre2 },
    { name: "Niña", img: Niña4 },
  ]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [reloadPreviews, setReloadPreviews] = useState(false);
  const [tipoRopa, setTipoRopa] = useState("Tipo ropa");
  const [selectedEngine, setSelectedEngine] = useState("Stable Diffusion");
  const [promptText, setPromptText] = useState("");
  const [loading, setLoading] = useState(false);

  // Determina si habilitar botón Generar
  const puedeGenerar = (() => {
    switch (selectedEngine) {
      case "Flux":
        // Solo necesita prompt
        return promptText.trim().length > 0;

      case "GPT 1 Image":
        // Prenda + prompt
        return (
          tipoRopa !== "Tipo ropa" && imagen && promptText.trim().length > 0
        );

      case "GPT 4o":
        // Prenda + modelo + prompt
        return (
          tipoRopa !== "Tipo ropa" &&
          imagen &&
          modeloSeleccionado &&
          promptText.trim().length > 0
        );

      case "Stable Diffusion":
        // Prenda + modelo
        return tipoRopa !== "Tipo ropa" && imagen && modeloSeleccionado;

      default:
        return false;
    }
  })();

  const isDisabled = tipoRopa === "Tipo ropa";

  const opcionesPrenda = [
    ["Camiseta m. corta", camiseta],
    ["Camiseta m. larga", camisetalarga],
    ["Hoodie", hoodie],
    ["Pants", pants],
  ];

  const labelMap = {
    "Camiseta m. corta": "Camiseta",
    "Camiseta m. larga": "Camiseta Larga",
    Hoodie: "Sudadera",
    Pants: "Pantalones",
  };

  const handleSeleccionarModelo = (nuevoModelo) => {
    if (nuevoModelo.name === modeloSeleccionado.name) return;
    const nuevos = modelosEnPantalla.filter((m) => m.name !== nuevoModelo.name);
    nuevos.unshift(modeloSeleccionado);
    setModeloSeleccionado(nuevoModelo);
    setModelosEnPantalla(nuevos.slice(0, 2));
    setMostrarModal(false);
  };

  // Sube un archivo al endpoint dado
  async function uploadSingleImage(endpoint, file) {
    const fd = new FormData();
    fd.append("image", file);
    const res = await fetch(endpoint, { method: "POST", body: fd });
    if (!res.ok) throw new Error(`Upload failed ${endpoint}`);
    return res.json();
  }

  const handleGenerarClick = async () => {
    onLoadingChange?.(true);
    try {
      console.log("Generación de imagen iniciada.");
      setLoading(true);

      if (selectedEngine === "Flux") {
      const formData = new FormData();
      formData.append("prompt", promptText.trim());

      const res = await fetch(`${API_BASE}/flux-model`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.image) {
        setResultUrl(data.image);
        onImageGenerated(data.image);
        console.log("Imagen generada con éxito (Flux):", data.image);
      } else {
        console.error("No se recibió imagen de Flux:", data);
      }
      return; // ← terminamos aquí; no necesitamos prenda ni modelo
    }
      console.log("Estado de loading: ", loading);

      // Verifica si imagen está correctamente cargada
      if (!imagen) {
        console.error("No se ha cargado ninguna imagen");
        return;
      }

      const respPrenda = await fetch(imagen);
      const blobPrenda = await respPrenda.blob();
      const filePrenda = new File([blobPrenda], "prenda.png", {
        type: blobPrenda.type,
      });

      console.log("Imagen de prenda cargada y convertida.");

      if (selectedEngine === "Stable Diffusion") {
        // Flujo MixOutfit: modelo + prenda
        const respModelo = await fetch(modeloSeleccionado.img);
        const blobModelo = await respModelo.blob();
        const fileModelo = new File(
          [blobModelo],
          `${modeloSeleccionado.name}.png`,
          { type: blobModelo.type }
        );

        console.log("Imagen del modelo cargada.");

        await uploadSingleImage(`${API_BASE}/upload-image-modelo`, fileModelo);
        await uploadSingleImage(`${API_BASE}/upload-image-prenda`, filePrenda);

        const runRes = await fetch(`${API_BASE}/run-python-script`, {
          method: "POST",
        });
        const runData = await runRes.json();
        if (runData.imageUrl) {
          setResultUrl(runData.imageUrl);
          onImageGenerated(runData.imageUrl);
          console.log("Imagen generada con éxito:", runData.imageUrl);
        }
      } else if (selectedEngine === "GPT 4o") {
        // Flujo GPT 4o: modelo + prenda + prompt
        const respModelo = await fetch(modeloSeleccionado.img);
        const blobModelo = await respModelo.blob();
        const fileModelo = new File(
          [blobModelo],
          `${modeloSeleccionado.name}.png`,
          { type: blobModelo.type }
        );

        const formData = new FormData();
        formData.append("person_img", fileModelo);
        formData.append("garment_img", filePrenda);
        formData.append("prompt", promptText.trim());

        const res = await fetch(`${API_BASE}/edit-image`, {
          method: "POST",
          body: formData,
        });
        const data = await res.json();
        if (data.imageUrl) {
          setResultUrl(data.imageUrl);
          onImageGenerated(data.imageUrl);
          console.log("Imagen generada con éxito:", data.imageUrl);
        }
      } else if (selectedEngine === "GPT 1 Image") {
        // Nuevo flujo: solo prenda + prompt
        const formData = new FormData();
        formData.append("garment_img", filePrenda);
        formData.append("prompt", promptText.trim());

        const res = await fetch(`${API_BASE}/edit1-prenda`, {
          method: "POST",
          body: formData,
        });
        const data = await res.json();
        if (data.imageUrl) {
          setResultUrl(data.imageUrl);
          onImageGenerated(data.imageUrl);
          console.log("Imagen generada con éxito:", data.imageUrl);
        }
      }

      setReloadPreviews(true);
      setTimeout(() => setReloadPreviews(false), 0);
    } catch (err) {
      console.error("Error generando imagen:", err);
    } finally {
      onLoadingChange?.(false);
      setLoading(false);
      console.log("Estado de loading después de generar: ", loading);
    }
  };

  return (
    <aside className="main">
      <h6 className="encabezado">Prueba tu imagen</h6>

      {/* Tipo de prenda */}
      <div className="menuprincipal-filtroprenda flex flex-col items-start">
        Escoge tipo de prenda:
        <div className="containerBotones flex space-x-2 mt-2">
          {opcionesPrenda.map(([label, src]) => {
            const isActive = tipoRopa === label;
            return (
              <button
                key={label}
                onClick={() => setTipoRopa(label)}
                data-tooltip={labelMap[label] || label}
                className="prenda-btn"
                style={{
                  border: isActive
                    ? "2px solid #4968F2"
                    : "1px solid transparent",
                  backgroundColor: "transparent",
                }}
              >
                <img src={src} alt={label} className="w-4 h-4 object-contain" />
              </button>
            );
          })}
        </div>
      </div>

      {/* Motor IA */}
      <div className="menuprincipal-filtroia flex flex-col items-start mt-4">
        Escoge modelo de IA:
        <DropdownButton
          id="dropdown-ia-model"
          title={selectedEngine}
          variant="secondary"
          className="w-full mt-2"
        >
          <Dropdown.Item onClick={() => setSelectedEngine("Stable Diffusion")}>
            <div className="d-flex flex-column align-items-start">
              <span className="fw-semibold">Stable Diffusion</span>
              <small className="text-muted">
                Motor inicial con balance óptimo entre velocidad y calidad.
              </small>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setSelectedEngine("GPT 4o")}>
            <div className="d-flex flex-column align-items-start">
              <span className="fw-semibold">GPT 4o</span>
              <small className="text-muted">
                Precisión avanzada para combinaciones detalladas.
              </small>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setSelectedEngine("GPT 1 Image")}>
            <div className="d-flex flex-column align-items-start">
              <span className="fw-semibold">GPT 1 Image</span>
              <small className="text-muted">
                Solo necesita una prenda + prompt (sin modelo).
              </small>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setSelectedEngine("Flux")}>
            <div className="d-flex flex-column align-items-start">
              <span className="fw-semibold">Flux</span>
              <small className="text-muted">
                Innovación sin límites en estilos y texturas.
              </small>
            </div>
          </Dropdown.Item>
        </DropdownButton>
        {["GPT 4o", "GPT 1 Image", "Flux"].includes(selectedEngine) && (
          <textarea
            className="mt-3 p-3 border rounded w-full h-40 resize-none textArea"
            placeholder="Escribe aquí tu prompt..."
            value={promptText}
            onChange={(e) => setPromptText(e.target.value)}
          />
        )}
      </div>

      {/* Upload + Generar */}
      <div className={isDisabled ? "disabled" : ""}>
        {selectedEngine !== "Flux" && (
          <div className="apartadoPrenda">
            <p className="texto">
              Sube tu prenda{" "}
              <FontAwesomeIcon className="iconoImagen" icon={faImage} />
            </p>
            <Previews
              onImageUpload={(img) => setImagen(img)}
              key={reloadPreviews ? "reload" : "keep"}
            />
          </div>
        )}
        {/* Bloque modelo + botón (solo si motor requiere modelo) */}
        {selectedEngine !== "GPT 1 Image" && selectedEngine !== "Flux" ? (
          <div className="apartadoModelo">
            <p className="texto">Escoge tu modelo</p>
            <div className="contenedorCards">
              {[modeloSeleccionado, ...modelosEnPantalla].map((m, i) => (
                <div
                  key={i}
                  className="card-container"
                  onClick={() => handleSeleccionarModelo(m)}
                >
                  <div
                    className={`card ${
                      m.name === modeloSeleccionado.name
                        ? "card-seleccionada"
                        : ""
                    }`}
                  >
                    <img src={m.img} alt={m.name} />
                  </div>
                  <p className="card-name">{m.name}</p>
                </div>
              ))}
              <div
                className="card-container"
                onClick={() => setMostrarModal(true)}
              >
                <div className="card add-card">+</div>
                <p className="card-name">Más Modelos</p>
              </div>
            </div>

            {/* Botón dentro de apartadoModelo */}
            <Button
              className="botonGenerar mt-3"
              onClick={handleGenerarClick}
              disabled={!puedeGenerar || loading}
            >
              {loading ? "Generando…" : "Generar Imagen"}
            </Button>
          </div>
        ) : (
          // Botón separado si es GPT 1 Image o Flux
          <div className="mt-4">
            <Button
              className="botonGenerar"
              onClick={handleGenerarClick}
              disabled={!puedeGenerar || loading}
            >
              {loading ? "Generando…" : "Generar Imagen"}
            </Button>
          </div>
        )}
      </div>

      <Modal
        show={mostrarModal}
        onHide={() => setMostrarModal(false)}
        onSeleccionarModelo={handleSeleccionarModelo}
        tipoRopa={tipoRopa}
        selectedEngine={selectedEngine}
      />
    </aside>
  );
}
